import { gql } from "@apollo/client";

export const GOOGLE_OAUTH_QUERY = gql`
  query Query($oauthData: GoogleOAuthDto!) {
    googleOAuthUrl(oauthData: $oauthData)
  }
`;
